module.exports = __webpack_public_path__ + "static/assets/103fe904046c35630c600cb122492d78.mp3";